module.exports = __webpack_public_path__ + "static/media/wavm8s-004-waller.9691dfc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-004-waller.mp3
// module id = Ppb1
// module chunks = 0